var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 919 267",
    style: {
      enableBackground: "new 0 0 919 267"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#417791;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000139994580820475456680000013069633580458387134_);}\n\t.st3{fill:url(#SVGID_00000054986996649308912310000007724997326947036340_);}\n\t.st4{fill:url(#SVGID_00000001648527242649966750000017587642815976571324_);}\n\t.st5{fill:url(#SVGID_00000070803959841758057820000009033367970021234095_);}\n\t.st6{fill:url(#SVGID_00000158012468069770340170000015611577836129407873_);}\n\t.st7{fill:url(#SVGID_00000028324728446348018770000017283565277469694872_);}\n\t.st8{fill:#605D5D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,52.4c7.8-13.7,19-25.2,32.6-33.2S68,6.5,84.9,6.5c12.5,0,24.4,2.5,35.2,7.1c16.2,6.9,30.1,18.3,39.8,32.7 c9.8,14.4,15.4,31.8,15.4,50.5c0,8-1.1,15.8-3,23.2c-0.2,0.9-0.1,1.8,0.4,2.5l25.2,40.8h-20.8c-0.9,0-1.7,0.3-2.3,0.9 c-0.6,0.6-1,1.4-1,2.3v62.1c0,1.8,1.5,3.2,3.2,3.2s3.2-1.5,3.2-3.2v-58.9h23.4c1.2,0,2.3-0.6,2.8-1.7c0.6-1,0.5-2.3-0.1-3.3 l-28.3-45.7l-2.8,1.7l3.1,0.8c2.1-7.9,3.2-16.3,3.2-24.9c0-13.4-2.7-26.1-7.6-37.7c-7.4-17.4-19.7-32.1-35.1-42.6 C123.6,6.1,104.9,0,84.9,0C66.8,0,49.8,5,35.3,13.6C20.8,22.2,8.7,34.5,0.4,49.2c-0.9,1.6-0.3,3.5,1.2,4.4 C3.2,54.5,5.2,53.9,6.1,52.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,98c0-9.6,2-18.8,5.5-27.1c5.3-12.5,14.2-23.1,25.4-30.6C56.5,32.8,70,28.4,84.5,28.4 c9.7,0,18.9,1.9,27.3,5.5c12.6,5.3,23.3,14.1,30.8,25.2c7.5,11.1,12,24.5,12,38.9c0,10.4-2.3,20.2-6.4,29.1 c-4.1,8.8-10,16.7-17.3,23.1l4.3,4.8c7.9-7,14.4-15.5,18.9-25.2c4.5-9.7,7-20.4,7-31.8c0-10.5-2.1-20.5-6-29.6 c-5.8-13.6-15.5-25.2-27.7-33.4c-12.2-8.2-26.9-13-42.8-13c-10.6,0-20.6,2.1-29.8,6C41,33.7,29.3,43.4,21.1,55.5 C12.8,67.7,8,82.3,8,98H14.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,136.9c-5.6-4.6-10.2-10.3-13.4-16.9c-3.2-6.6-5-13.9-5-21.8c0-6.9,1.4-13.4,3.9-19.4 c3.8-8.9,10-16.5,17.9-21.9c7.9-5.4,17.4-8.5,27.7-8.5c6.8,0,13.3,1.4,19.3,3.9c8.9,3.8,16.4,10.1,21.8,18s8.5,17.5,8.5,27.8h6.5 c0-7.8-1.6-15.2-4.4-21.9c-4.2-10.1-11.4-18.7-20.3-24.8C106.4,45.5,95.6,42,84,42c-7.7,0-15.1,1.6-21.8,4.4 c-10.1,4.3-18.6,11.4-24.6,20.4c-6,9-9.6,19.8-9.6,31.5c0,8.8,2,17.2,5.6,24.6c3.6,7.4,8.8,14,15.1,19.1L52.9,136.9L52.9,136.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,98c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C15.4,90,19,93.6,19,98z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M145,98c0,4.4-3.6,8-8,8s-8-3.6-8-8c0-4.4,3.6-8,8-8S145,93.6,145,98z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,147c4.1,0,7.5-3.6,7.5-8s-3.4-8-7.5-8s-7.5,3.6-7.5,8S47.4,147,51.5,147z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140,153c0,4.4-3.4,8-7.5,8s-7.5-3.6-7.5-8s3.4-8,7.5-8S140,148.6,140,153z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.5,263.8v-31.4h60.3c1.8,0,3.2-1.4,3.2-3.2c0-1.8-1.5-3.2-3.2-3.2h-63.5c-0.8,0-1.7,0.3-2.3,0.9 c-0.6,0.6-0.9,1.4-0.9,2.3v34.6c0,1.8,1.5,3.2,3.2,3.2S116.5,265.6,116.5,263.8L116.5,263.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.3,115.9c5.6-5.6,5.6-14.6,0-20.2c-5.6-5.6-14.6-5.6-20.2,0c-5.6,5.6-5.6,14.6,0,20.2 C79.7,121.5,88.7,121.5,94.3,115.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,173c0,4.4-3.6,8-8,8s-8-3.6-8-8s3.6-8,8-8S92,168.6,92,173z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135,192c0,3.3-2.5,6-5.5,6c-3,0-5.5-2.7-5.5-6s2.5-6,5.5-6C132.5,186,135,188.7,135,192z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,200c4.1,0,7.5-3.4,7.5-7.5s-3.4-7.5-7.5-7.5s-7.5,3.4-7.5,7.5S35.4,200,39.5,200z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,247c3,0,5.5-2.5,5.5-5.5s-2.5-5.5-5.5-5.5c-3,0-5.5,2.5-5.5,5.5S59.5,247,62.5,247z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.6397,
    y1: 43.1998,
    x2: 315.1597,
    y2: 193.4098,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268,172.8h-15l24.9-66.9c3.1-9.2,8.2-14.9,18.9-14.9c11.9,0,17.9,7,17.9,17.5V156c0,2.7,1.7,4.5,4,4.5 c2.1,0,3.8-1.3,4.5-3.3l19.5-51.3c3.1-9.2,8.2-14.9,18.9-14.9c11.9,0,17.9,7,17.9,17.5v64.3h-14.2v-63.6c0-2.9-1.7-4.6-4-4.6 c-2,0-3.7,1.4-4.4,3.5l-19.5,51.3c-3.1,9.2-8.3,14.9-19,14.9c-11.8,0-17.7-7-17.7-17.6v-47.4c0-2.9-1.8-4.6-4.2-4.6 c-2.1,0-3.6,1.4-4.4,3.4L268,172.8L268,172.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070830247932310837130000007239963516831563444_",
    gradientUnits: "userSpaceOnUse",
    x1: 431.0282,
    y1: 45.0698,
    x2: 428.5482,
    y2: 195.2798,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070830247932310837130000007239963516831563444_)"
    },
    d: "M463,92.4v14h-40.2 c-8.5,0-12.1,3.9-12.1,10.1c0,6.5,4.2,9.5,12.3,9.5h39.5v12.7h-39.9c-8.1,0-12.3,3.2-12.3,9.8s3.9,10.1,12.1,10.1h40.7v14h-40.7 c-19,0-26.8-9.4-26.8-21.9c0-9.2,4.2-15.3,11.5-18.4c-7.5-3.1-11.3-9.3-11.3-18.1c0-12.8,8-21.9,26.9-21.9L463,92.4L463,92.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145750241340243353000000011655528544729397950_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.5059,
    y1: 46.4998,
    x2: 515.0159,
    y2: 196.7097,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145750241340243353000000011655528544729397950_)"
    },
    d: "M524.7,92.4c18.1,0,25.8,11.2,25.8,24 c0,10-4.8,20.7-17,24.2l18.7,32.1h-15.6l-18.3-31.1h-20.9c-1.3,0-2,0.6-2,2v29h-14V141c0-9,3.8-12.7,12.6-12.7h31.3 c8,0,11.2-5.5,11.2-11.2s-3.5-10.6-11.2-10.6h-44v-14L524.7,92.4L524.7,92.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114051955841115018680000009049251354987099577_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.806,
    y1: 47.4499,
    x2: 572.316,
    y2: 197.6599,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114051955841115018680000009049251354987099577_)"
    },
    d: "M580.4,92.4v80.3h-14V92.4H580.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001635773876373226540000018227300008954850995_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.5151,
    y1: 48.4699,
    x2: 634.0251,
    y2: 198.6799,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001635773876373226540000018227300008954850995_)"
    },
    d: "M634.8,92.4c23.4,0,36.2,13.1,36.2,40.2 s-12.6,40.1-36.2,40.1h-28.3c-4.5,0-6.7-2.1-6.7-6.5V99c0-4.4,2.1-6.5,6.7-6.5L634.8,92.4L634.8,92.4z M613.8,157.3 c0,1.1,0.5,1.4,1.5,1.4h19.4c15.6,0,22.1-7.7,22.1-26.2s-6.5-26.1-22.1-26.1h-19.4c-1.1,0-1.5,0.4-1.5,1.4V157.3L613.8,157.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057830055558945181980000000050464876663624873_",
    gradientUnits: "userSpaceOnUse",
    x1: 695.9128,
    y1: 49.4499,
    x2: 693.4229,
    y2: 199.6599,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057830055558945181980000000050464876663624873_)"
    },
    d: "M701.5,92.4v80.3h-14V92.4H701.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160164836460739880310000012407575033326530731_",
    gradientUnits: "userSpaceOnUse",
    x1: 761.097,
    y1: 50.5298,
    x2: 758.6071,
    y2: 200.7398,
    gradientTransform: "matrix(1 0 0 -1 0 267.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DE340D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF6825"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160164836460739880310000012407575033326530731_)"
    },
    d: "M765.2,92.4c23.3,0,36.3,13.3,36.3,40.3 s-12.8,40-36.3,40h-11c-23.4,0-36.3-13.1-36.3-40s13-40.3,36.3-40.3H765.2z M754.2,106.5c-15.5,0-22.2,7.8-22.2,26.3 s6.7,25.9,22.2,25.9h11c15.5,0,22.1-7.6,22.1-26.1s-6.7-26.2-22.1-26.2H754.2z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M884.9,153.7l-5.3-14L865,101.4c-2.9-7.5-8.3-10.4-16.7-10.4c-8.3,0-13.9,2.9-16.9,10.4l-28.2,71.4h15.5 l7.5-19.1l5.5-14l12.4-31.5c0.8-1.9,2.1-2.7,4-2.7s3.2,0.8,3.9,2.7l11.9,31.5l5.3,14l7.2,19.1h15.6L884.9,153.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M918.1,92.4v80.3h-14V92.4H918.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M879.6,139.6h-59.4v14h64.7L879.6,139.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c2af4e3d78bc6744474aa64bebe668b3.svg";
export { ForwardRef as ReactComponent };